var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n        fill: #4a4d57;\n        fill-rule: evenodd;\n      }\n    ")),React.createElement("path",{"id":"Linkedin","className":"cls-1","d":"M1473.58,5082h-3.32v-10.02h3.32V5082Zm-1.66-11.39a1.808,1.808,0,1,1,1.92-1.8A1.866,1.866,0,0,1,1471.92,5070.61ZM1486,5082h-3.31v-4.87c0-1.16-.03-2.66-1.73-2.66-1.72,0-1.99,1.27-1.99,2.57V5082h-3.31v-10.02h3.18v1.37h0.05a3.513,3.513,0,0,1,3.13-1.62c3.36,0,3.98,2.08,3.98,4.77v5.5Z","transform":"translate(-1470 -5067)","key":1})]);
}

Linkedin.defaultProps = {"width":"16","height":"15","viewBox":"0 0 16 15"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
